// extracted by mini-css-extract-plugin
module.exports = {"tab":"_0fea0","wrapper":"_8d54a","spinner":"_49e8f","tabs":"_93cc9","active":"a005d","card-container":"fc6d7","cardContainer":"fc6d7"};